import NavigateNext from '@mui/icons-material/NavigateNext'
import { Breadcrumbs, Link, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { BreadcrumbItem } from '../hooks/useFileRepository'

interface FileRepositoryBreadcrumbsProps {
  breadcrumbs: BreadcrumbItem[]
  onNavigate: (index: number) => void
}

export function FileRepositoryBreadcrumbs({
  breadcrumbs,
  onNavigate,
}: FileRepositoryBreadcrumbsProps) {
  const { t } = useTranslation()

  return (
    <Breadcrumbs
      separator={<NavigateNext fontSize="small" />}
      sx={{ mb: '16px' }}
    >
      {breadcrumbs.map((crumb, index) => {
        const isLast = index === breadcrumbs.length - 1
        const label = crumb.id === null ? t(crumb.name) : crumb.name

        return isLast ? (
          <Typography key={index} color="text.primary" fontWeight={500}>
            {label}
          </Typography>
        ) : (
          <Link
            key={index}
            component="button"
            underline="hover"
            color="inherit"
            onClick={() => onNavigate(index)}
            sx={{
              cursor: 'pointer',
              ':hover': { color: '#FF5E1E' },
            }}
          >
            {label}
          </Link>
        )
      })}
    </Breadcrumbs>
  )
}
